import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES } from "@/lib/api";
import { CoverPicker } from "@/components/dashboard/CoverPicker";

const EMPTY = { title: "", description: "", category: "jovens", access_type: "open", is_live: true };

export function RoomFormDialog({ open, onOpenChange, initial, onSave }) {
  const [f, setF] = useState(initial ? { title: initial.title, description: initial.description || "", category: initial.category, access_type: initial.access_type, is_live: initial.is_live } : EMPTY);
  const [cover, setCover] = useState(initial?.cover_url ? { public_id: initial.cover_public_id || null, preview: initial.cover_url, original: true } : null);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const data = { ...f };
    if (!cover?.original) data.cover_public_id = cover?.public_id || (initial ? "" : null);
    try { await onSave(data); } finally { setSaving(false); }
  };
  const accessOpt = (key, title, desc) => (
    <button type="button" onClick={() => setF({ ...f, access_type: key })} data-testid={`access-type-${key}`}
      className={`rounded-xl border p-3 text-left transition-colors ${f.access_type === key ? "border-[hsl(var(--gold))] bg-[hsl(var(--gold))]/10" : "border-white/10 hover:border-white/30"}`}>
      <p className="text-sm font-bold">{title}</p>
      <p className="text-xs text-muted-foreground">{desc}</p>
    </button>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="room-form-dialog">
        <DialogHeader><DialogTitle>{initial ? "Editar sala" : "Nova sala de transmissão"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Título</Label><Input required minLength={3} maxLength={80} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="room-title-input" /></div>
          <div className="space-y-1.5"><Label>Descrição</Label><Textarea value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="room-description-input" /></div>
          <div className="space-y-1.5">
            <Label>Grupo de interesse</Label>
            <Select value={f.category} onValueChange={(v) => setF({ ...f, category: v })}>
              <SelectTrigger data-testid="room-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(CATEGORIES).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>Critério de ingresso</Label>
            <div className="grid grid-cols-2 gap-2">
              {accessOpt("open", "Entrada Livre Verificada", "Usuários cadastrados entram direto")}
              {accessOpt("approval", "Com Aprovação", "Pedido vai ao seu painel")}
            </div>
          </div>
          <div className="space-y-1.5"><Label>Capa da sala</Label><CoverPicker preview={cover?.preview} onChange={setCover} onBusy={setUploading} />
            <p className="text-[11px] text-muted-foreground">A foto é analisada pelo Guarda-Costas IA ao salvar.</p></div>
          <label className="flex items-center justify-between rounded-xl bg-white/5 p-3 text-sm font-semibold">
            Transmitindo ao vivo agora
            <Switch checked={f.is_live} onCheckedChange={(v) => setF({ ...f, is_live: v })} data-testid="room-live-switch" />
          </label>
          <Button type="submit" disabled={saving || uploading} className="w-full rounded-full" data-testid="room-save-button">{saving ? (cover && !cover.original ? "A analisar capa com IA…" : "Salvando…") : uploading ? "A enviar capa…" : "Salvar sala"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
